import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';
import { UserInfo } from './types/user-info';
import { UserFragment } from './fragments/user.fragment';
import { UserProfileBaseFragment } from './fragments/user-profile.fragment';


export interface UserInfoResponse {
  userById: UserInfo;
}


@Injectable({
  providedIn: 'root',
})
export class UserInfoGQL extends Query<UserInfoResponse> {
  document = gql`
    query userInfo($id: ObjectId!, $lang: String!){
      userById(id: $id, lang: $lang){
        ...userFields
        profile {
          ...userProfileBase
        }
    }
  }
  ${UserFragment}
  ${UserProfileBaseFragment}
  `;
}
